export enum PassengerType {
  Adult = 'Adult',
  Child = 'Child',
  Senior = 'Senior',
  Handicapped = 'Handicapped',
  Young = 'Young',
  Bike = 'Bike',
  Dog = 'Dog',
  Unknown = 'Unknown'
}